import { Component } from '@angular/core';
import { BenefitsButtonComponent } from './benefits-button/benefits-button.component';
import { BenefitsContainerComponent } from './benefits-container/benefits-container.component';

@Component({
    selector: 'app-benefits',
    imports: [
        BenefitsButtonComponent,
        BenefitsContainerComponent
    ],
    templateUrl: './benefits.component.html',
    styleUrl: './benefits.component.css'
})
export class BenefitsComponent {

}
